import { isNotNil } from '../../util/object';

import {
  DEFAULT_CREATIVE_HEIGHT_PX,
  DEFAULT_CREATIVE_WIDTH_PX,
  MIN_FRAMES_PER_CREATIVE_PARTIALS,
} from './constants';
import { DEFAULT_CREATIVE_LENGTH } from '../../constants';

export const getEmptyCreativeState = (duration = DEFAULT_CREATIVE_LENGTH) => {
  return {
    content: {
      content: [],
      contentById: {},
    },
    elements: {
      elements: [],
      elementsById: {},
      masks: {
        root: {
          color: '#FFFFFF',
          height: DEFAULT_CREATIVE_HEIGHT_PX,
          frameEnd: duration,
          frameStart: 0,
          type: 'RECTANGLE',
          width: DEFAULT_CREATIVE_WIDTH_PX,
        },
      },
    },
    media: {
      media: [],
      mediaById: {},
    },
  };
};

export const getCreativePartials = (
  creativeFrameEnd,
  expectedFramesPerPartial,
  minimumFramesPerPartial = MIN_FRAMES_PER_CREATIVE_PARTIALS,
) => {
  if (expectedFramesPerPartial === 0) {
    throw new Error('Expected frames must be greater than 0');
  }

  if (expectedFramesPerPartial <= minimumFramesPerPartial) {
    throw new Error('Expected frames must be greater than minimum frames');
  }

  // if total frame numbers is less than expected, return early
  if (creativeFrameEnd + 1 <= expectedFramesPerPartial) {
    return [{ start: 0, end: creativeFrameEnd }];
  }

  const numOfOutputRangesNeeded = Math.ceil(
    creativeFrameEnd / expectedFramesPerPartial,
  );
  const outputRanges = [];
  for (let i = 0; i < numOfOutputRangesNeeded; i++) {
    const start = i * expectedFramesPerPartial;
    const end = Math.min(
      (i + 1) * expectedFramesPerPartial - 1,
      creativeFrameEnd,
    );
    const lastOutputRange = outputRanges[outputRanges.length - 1];

    const totalFrames = end - start + 1;
    if (totalFrames <= minimumFramesPerPartial && isNotNil(lastOutputRange)) {
      lastOutputRange.end = end;
      break;
    }

    outputRanges.push({ start, end });
  }

  return outputRanges;
};
